import { TaxonomyMasterPage } from "@/components/taxonomy-master-page";

export default function Buckets() {
  return (
    <TaxonomyMasterPage
      kind="bucket"
      title="Buckets"
      hint="Which part of an interview a question belongs to (DESIGN §17.2). A bucket is not stored on a question — it groups stacks, and each stack names its bucket on the Stacks page."
    />
  );
}
